import { schema } from "normalizr";
import { Item } from "schemas/items";
import { CatalogEntry as Record } from "records/catalog";

const CatalogEntry = new schema.Entity(
    "entries",
    {
        item: Item,
    },
    {
        idAttribute: "id",
    },
);

CatalogEntry.record = Record;

export default CatalogEntry;
